import { usePerfilOficialSectionsStore } from '~/stores/apostatudo/perfil-oficial-sections';
import { useOfficialProfilesStore } from '~/stores/apostatudo/official-profiles';
import { buildSectionDataFromOfficialProfile } from '~/utils/apostatudo/official-profile-sections';

export const usePerfilOficialSections = () => {
  const store = usePerfilOficialSectionsStore();
  const officialProfilesStore = useOfficialProfilesStore();

  const fetchSections = async (slug: string) => {
    // Se já tem dados para este slug, não refaz requisição
    if (store.currentSlug === slug && store.hasItems) return;

    // Slug diferente → resetar dados anteriores antes de buscar
    if (store.currentSlug !== slug) {
      store.reset();
    }

    store.loading = true;
    store.error = null;
    store.currentSlug = slug;

    try {
      // As seções e a ordem delas são as categorias do perfil no core. O
      // detalhe já está em cache quando a página carregou o perfil.
      const profile = await officialProfilesStore.fetchDetail(slug);

      if (!profile) {
        store.error = 'Perfil oficial não encontrado na API';

        return;
      }

      store.setSectionData(await buildSectionDataFromOfficialProfile(profile));
    } catch (error) {
      console.error('[usePerfilOficialSections] Erro:', error);
      store.error =
        error instanceof Error ? error.message : 'Erro desconhecido';
    } finally {
      store.loading = false;
    }
  };

  return {
    fetchSections,
    sortedItems: computed(() => store.sortedItems),
    validItems: computed(() => store.validItems),
    hasItems: computed(() => store.hasItems),
    loading: computed(() => store.loading),
    error: computed(() => store.error),
  };
};
